export const misc = {
	zIndex: {
		meterBanner: 1000,
		backdrop: 1100,
		paywallPrompt: 1200,
		slideoutNav: 1300,
		modal: 1400
	}
}
